export default "__VITE_ASSET__B92uAT5f__"